import React from "react";
import { BaseUrl } from "../../helper/BaseUrl";

export default function DynamicBg({ aiData, onAction }) {
  if (!aiData?.readyToElevate) return null;

  return (
    <section className="ready-to-elevate-section  dynamic-cta-section">
      <div className="container">
        <div   className="ready-to-elevate-background"
          style={{  "--ready-to-elevate-image": `url("${BaseUrl}${aiData?.readyToElevate?.backgroundImage}")`,  }} >
          <div className="row">
            <div className="col-lg-7 col-md-9">
              <div className="ready-to-elevate-content">
                <h2 className="heading"> {aiData?.readyToElevate?.title} </h2>
                <button  type="button" className="default-btn white-font"  onClick={onAction} >
                  {aiData?.readyToElevate?.button}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
